import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfcd15a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100 fs-9" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "pt-4" }
const _hoisted_8 = { class: "bg-gray p-2 mx-4 fw-bold d-flex" }
const _hoisted_9 = { class: "row px-4 mt-3" }
const _hoisted_10 = { class: "col-lg-12 stripe-table-no-header" }
const _hoisted_11 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_12 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_13 = { class: "col-lg-2 d-flex fs-7 mt-2" }
const _hoisted_14 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_15 = { class: "py-4" }
const _hoisted_16 = { class: "active first-li fw-bold mb-3 position-relative text-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "align-content-center text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down fs-6" })
], -1))
const _hoisted_18 = { class: "bg-gray p-2 mx-4 fw-bold d-flex" }
const _hoisted_19 = { class: "row px-4" }
const _hoisted_20 = { class: "col-lg-6 stripe-table" }
const _hoisted_21 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_22 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_23 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_24 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_25 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_26 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_27 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_28 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_29 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_30 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_31 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_32 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_33 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_34 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_35 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_36 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_37 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_38 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_39 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_40 = { class: "col-lg-6 stripe-table" }
const _hoisted_41 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_42 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_43 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_44 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_45 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_46 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_47 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_48 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_49 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_50 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_51 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_52 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_53 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_54 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_55 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_56 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_57 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_58 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_59 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_60 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_61 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_62 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_63 = { class: "row px-4" }
const _hoisted_64 = { class: "col-lg-12 stripe-table" }
const _hoisted_65 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_66 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_67 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_68 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_69 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_70 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_71 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_72 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_73 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_74 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_75 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_76 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_77 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_78 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_79 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_80 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_81 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_82 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_83 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_84 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_85 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_86 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_87 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_88 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_89 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_90 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_91 = { class: "row px-4" }
const _hoisted_92 = { class: "col-lg-12" }
const _hoisted_93 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_94 = { class: "mb-5 mb-lg-0 row bg-light mx-0 p-2" }
const _hoisted_95 = { class: "d-flex align-items-center pt-2 fs-7 break-spaces text-break" }
const _hoisted_96 = { class: "mt-4 fw-bold text-center fs-7 border-bottom py-4 border-top" }
const _hoisted_97 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_98 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_99 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_100 = {
  class: "modal fade",
  id: "modalSuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_101 = { class: "modal-dialog" }
const _hoisted_102 = { class: "modal-content" }
const _hoisted_103 = { class: "modal-header" }
const _hoisted_104 = { class: "modal-title fs-7 fw-bold text-center w-100" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_106 = { class: "content mx-auto" }
const _hoisted_107 = { class: "text-center my-4 fs-7" }
const _hoisted_108 = { class: "modal-footer row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_109 = { class: "d-flex col-lg-12 justify-content-center" }

import { onMounted, PropType, ref } from 'vue'
import { omit } from 'lodash'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import adminRegisterService from '@/services/admin-register-alumni.service'
import { InvitationKeyType } from '@/constants/type'
import { Modal } from 'bootstrap'
import { ALUMNI_QUESTION_TYPE, FORM_TYPE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  additionalData: Object as PropType<{
    addl_info_1_type: number
    addl_info_2_type: number
    addl_info_3_type: number
    addl_info_4_type: number
    addl_info_5_type: number
    addl_info_1_list: Array<string>
    addl_info_2_list: Array<string>
    addl_info_3_list: Array<string>
    addl_info_4_list: Array<string>
    addl_info_5_list: Array<string>
  }>,
  data: Object as PropType<{
    corporation_department_name: number
    corporation_period: number
    corporation_employee_id: number
    corporation_email: number
    corporation_name: number
    school_faclty_name: number
    school_department_name: number
    school_period: number
    school_student_id: number
    school_email: number
    school_name: number
    additional_information_1_question: string
    additional_information_1_setting?: any
    additional_information_1: number
    additional_information_2_question: string
    additional_information_2_setting?: any
    additional_information_2: number
    additional_information_3_question: string
    additional_information_3_setting?: any
    additional_information_3: number
    additional_information_4_question: string
    additional_information_4_setting?: any
    additional_information_4: number
    additional_information_5_question: string
    additional_information_5_setting?: any
    additional_information_5: number
    supplementary_information: string
    school_organization_name: string
    corporation_organization_name: string
  }>,
  invitationKeys: Array as PropType<Array<InvitationKeyType>>,
  currentTabLabel: String,
},
  setup(__props, { expose }) {

const props = __props



const updateFailed = ref<boolean>(false)
// 2022/09/15 TienNV Fix double click button confirm
const modalConfirm = ref()
const modalSuccess = ref()
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirm'))
  modalSuccess.value = new Modal(document.getElementById('modalSuccess'))
})
const loading = ref(false)

const normalizeArray = (additional_information_type, arr) => {
  //input ['1','2','',''] => ['1','2']
  //Type not show[0] => not send data list check => return []
  if (additional_information_type === 0 || arr?.length == 0) {
    return [] // if type = 0, return []
  }

  return arr?.filter((item) => item?.trim() !== '') // remove object empty
}

const PutEntry = async (): Promise<void> => {
  loading.value = true
  var dataEntry = omit(props.data, ['community_id', 'id'])
  props.invitationKeys?.forEach((invitationKey) => {
    dataEntry[`invited_route_name_${invitationKey.invited_route}`] = invitationKey.invited_route_name
    dataEntry[`invited_route_is_default_${invitationKey.invited_route}`] = invitationKey.is_default
    dataEntry[`invited_route_form_type_${invitationKey.invited_route}`] = invitationKey.entry_form_value
  })
  dataEntry = {
    ...dataEntry,
    ...{
      additional_information_1_setting: {
        type: dataEntry.additional_information_1 == 0 ? 0 : props.additionalData?.addl_info_1_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_1 == 0 ? [] : normalizeArray(props.data?.additional_information_1, props.additionalData?.addl_info_1_list),
      },
      additional_information_2_setting: {
        type: dataEntry.additional_information_2 == 0 ? 0 : props.additionalData?.addl_info_2_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_2 == 0 ? [] : normalizeArray(props.data?.additional_information_2, props.additionalData?.addl_info_2_list),
      },
      additional_information_3_setting: {
        type: dataEntry.additional_information_3 == 0 ? 0 : props.additionalData?.addl_info_3_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_3 == 0 ? [] : normalizeArray(props.data?.additional_information_3, props.additionalData?.addl_info_3_list),
      },
      additional_information_4_setting: {
        type: dataEntry.additional_information_4 == 0 ? 0 : props.additionalData?.addl_info_4_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_4 == 0 ? [] : normalizeArray(props.data?.additional_information_4, props.additionalData?.addl_info_4_list),
      },
      additional_information_5_setting: {
        type: dataEntry.additional_information_5 == 0 ? 0 : props.additionalData?.addl_info_5_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_5 == 0 ? [] : normalizeArray(props.data?.additional_information_5, props.additionalData?.addl_info_5_list),
      },
    },
  }

  try {
    const response = await adminRegisterService.putEntryFormApi(props.data.community_id, { community_required_column: dataEntry })
    if (response?.status === 200) {
      updateFailed.value = false
    } else {
      updateFailed.value = true
    }
    //2022/09/15 TienNV Fix double click button confirm
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loading.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    updateFailed.value = false
    //2022/09/15 TienNV Fix double click button confirm
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
  }
}

expose({
  showConfirmModal: (): void => modalConfirm.value.show(),
})

const radio = ref([
  {
    value: 0,
    title: translate('CG40unnecessary'),
  },
  {
    value: 1,
    title: translate('CG40required'),
  },
  {
    value: 2,
    title: translate('CG40any'),
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CG41title')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('invitationUrl')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.invitationKeys, (invitationKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-5 mb-lg-0 row mx-0 p-2",
                    key: invitationKey.invited_route
                  }, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(invitationKey.invited_route_name_default), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(invitationKey.invited_route_name || invitationKey.invited_route_name_default), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)(_unref(FORM_TYPE)[invitationKey.entry_form_value])), 1),
                    (invitationKey.is_default)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(Button, {
                            title: _unref(translate)('SE40userinvitationurl'),
                            type: 'primary',
                            size: 'small',
                            className: 'false fw-bold m-w-unset mt-lg-0 order-4 order-lg-3 primary shadow'
                          }, null, 8, ["title"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(_toDisplayString(__props.currentTabLabel) + " ", 1),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(translate)('OE30additionalItems')), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(translate)('forCompanies')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_organization_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)('SA20department')), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_department_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('enrollment')), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_period)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(translate)('SA20employeeID')), 1),
                  _createElementVNode("div", _hoisted_33, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_employee_id)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_email)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
                  _createElementVNode("div", _hoisted_39, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_name)?.title), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(translate)('forSchool')), 1),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_organization_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
                  _createElementVNode("div", _hoisted_47, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_faclty_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
                  _createElementVNode("div", _hoisted_50, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_department_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
                  _createElementVNode("div", _hoisted_53, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_period)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(translate)('SA20studentID')), 1),
                  _createElementVNode("div", _hoisted_56, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_student_id)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
                  _createElementVNode("div", _hoisted_59, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_email)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
                  _createElementVNode("div", _hoisted_62, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_name)?.title), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(translate)('additionalInformation')), 1),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_unref(translate)('additionalInformation1Question')), 1),
                  _createElementVNode("div", _hoisted_68, _toDisplayString(__props.data?.additional_information_1_question), 1),
                  _createElementVNode("div", _hoisted_69, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_1)?.title), 1),
                  (__props.additionalData?.addl_info_1_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_1 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_1_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("label", _hoisted_72, _toDisplayString(_unref(translate)('additionalInformation2Question')), 1),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(__props.data?.additional_information_2_question), 1),
                  _createElementVNode("div", _hoisted_74, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_2)?.title), 1),
                  (__props.additionalData?.addl_info_2_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_2 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_2_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("label", _hoisted_77, _toDisplayString(_unref(translate)('additionalInformation3Question')), 1),
                  _createElementVNode("div", _hoisted_78, _toDisplayString(__props.data?.additional_information_3_question), 1),
                  _createElementVNode("div", _hoisted_79, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_3)?.title), 1),
                  (__props.additionalData?.addl_info_3_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_3 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_3_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("label", _hoisted_82, _toDisplayString(_unref(translate)('additionalInformation4Question')), 1),
                  _createElementVNode("div", _hoisted_83, _toDisplayString(__props.data?.additional_information_4_question), 1),
                  _createElementVNode("div", _hoisted_84, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_4)?.title), 1),
                  (__props.additionalData?.addl_info_4_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_4 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_4_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", _hoisted_87, _toDisplayString(_unref(translate)('additionalInformation5Question')), 1),
                  _createElementVNode("div", _hoisted_88, _toDisplayString(__props.data?.additional_information_5_question), 1),
                  _createElementVNode("div", _hoisted_89, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_5)?.title), 1),
                  (__props.additionalData?.addl_info_5_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_5 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_5_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, _toDisplayString(_unref(translate)('supplementaryInformation')), 1),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, _toDisplayString(__props.data?.supplementary_information), 1)
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_96, _toDisplayString(_unref(translate)('updateQuestion')), 1),
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createVNode(Button, {
                  title: _unref(translate)('titleButtonEdit'),
                  type: 'secondary',
                  className: 'fw-bold',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createVNode(Button, {
                  title: _unref(translate)('update'),
                  type: 'secondary',
                  className: 'fw-bold',
                  onClick: PutEntry,
                  loading: loading.value,
                  disabled: loading.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_100, [
      _createElementVNode("div", _hoisted_101, [
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("h5", _hoisted_104, _toDisplayString(_unref(translate)('CG42title')), 1),
            _hoisted_105
          ]),
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("div", _hoisted_107, _toDisplayString(updateFailed.value ? _unref(translate)('CG40updateFailed') : _unref(translate)('updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})